import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { CustomToggle } from './CustomToggle';

import './FilterDropDown.scss';

export interface FilterGroup {
  label: string;
  value: string;
  icon?: React.ReactNode;
  options: { label: string; value: string }[];
}

interface FilterDropdownProps {
  groups: FilterGroup[];
  onSelect: (group: string, value: string) => void;
  selected: { [group: string]: string[] };
  iconOnly?: boolean;
}

export const FilterDropdown = ({ groups, onSelect, selected, iconOnly }: FilterDropdownProps) => {
  const [expandedGroup, setExpandedGroup] = useState<string | null>(null);

  const handleToggle = (isOpen: boolean) => {
    if (!isOpen) setExpandedGroup(null);
  };

  return (
    <Dropdown onToggle={handleToggle}>
      <Dropdown.Toggle id="filter-dropdown-toggle" as={CustomToggle} iconOnly={iconOnly} />
      <Dropdown.Menu className="filter-dropdown__menu">
        <div className="filter-dropdown__content">
          <div>
            {groups?.map((group) => (
              <div key={group.label} className="filter-dropdown__item" onClick={() => setExpandedGroup(expandedGroup === group.value ? null : group.value)}>
                {group.icon}
                {group.label}
              </div>
            ))}
          </div>

          {expandedGroup && (
            <div>
              {groups
                .find((group) => group.value === expandedGroup)
                ?.options?.map((opt) => {
                  return (
                    <Dropdown.Item
                      key={opt.value}
                      className={`filter-dropdown__item ${selected[expandedGroup]?.find((item) => item === opt.value) ? ' active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelect(expandedGroup, opt.value);
                      }}
                    >
                      {opt.label}
                    </Dropdown.Item>
                  );
                })}
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
